module.exports = __webpack_public_path__ + "static/media/SacredHeartKingston.93cbf29a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schools/main/SacredHeartKingston.jpg
// module id = 752
// module chunks = 0